import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CommonFunctionsService } from './common-functions.service';
import { DatastoreService } from './datastore.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const dataStore = inject(DatastoreService);
  const commonFunctionsService = inject(CommonFunctionsService);

  await commonFunctionsService.setCompanyName(route.params);

  if (!JSON.parse(dataStore.config).requireLogin) {
    return true;
  }

  commonFunctionsService.alreadyLoggedIn();

  if (!dataStore.loggedIn) {
    router.navigate([
      `${commonFunctionsService.getCompanyName()}/${commonFunctionsService.getCompanyId()}/access`,
    ]);
    return false;
  }
  // there currently is no "logged in" functionality in the registration app (?)
  return true;
};
